import { observer } from 'mobx-react-lite';
import CanvasResolutionSpec from './CanvasResolutionSpec';
import type { CanvasResolutionSpecProps, CanvasResolutionSpecValueProps } from './types';

export type { CanvasResolutionSpecProps, CanvasResolutionSpecValueProps };
export default observer(CanvasResolutionSpec); // MANUAL OVERRIDE
